import { TenantIntegrationKey, UserTenant } from '@root/globalTypes';
import { Emptied } from '@utils/types';

export const isIntegrationEnabled = (
  tenant: Emptied<UserTenant> | undefined,
  name: TenantIntegrationKey,
) => Boolean(tenant?.integrations?.some((el) => el[name]));
